<template>
  <div class="dashboard-container">
      <el-row :gutter="24">
        <el-col :span="7"  v-for="(item, index) in infoList"
                :key="item.title" style="margin: 20px;">
          <el-card shadow="always" :body-style="{ padding: '10px',margin: '20px' ,height: '200px'}">
            <div class="description-row-column">
              <div class="title">{{ item.title }}</div>
              <div class="total-num" :style="{ color: numColorMap[index],'font-size':'80px' }">
                {{ item.num }}
              </div>
              <el-divider v-if="item.compare" />
              <div v-if="item.compare" class="yesterday-row">
                <div class="yesterday-title">
                  {{ item.compare.subTitle ? item.compare.subTitle + ":" : "" }}{{ item.compare.subNum || "" }}
                </div>
                <div class="yesterday-count"></div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
  </div>
</template>

<script>
import { pluck, equals } from 'ramda'
import { getAnalysis, getUserRegStatistics } from '@/api/dashboard'
import dayjs from 'dayjs'
import { numColorMap } from './const'
export default {
  name: 'Dashboard',
  components: {},
  data() {
    return {
      numColorMap,
      lineOptions: {},
      infoList: [],
      loading: false,
      currMonth: dayjs().format('YYYY-MM')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    /**
     * 请求接口获取数据
     */
    async fetchData() {
      const { data } = await getAnalysis()
      this.infoList = data
    },
  }
}
</script>

<style lang="scss" scoped>
.echarts {
  width: 90%;
  height: 90%;
}
.dashboard {
  &-container {
    margin: 10px;
    margin-top: 35px;
    &-text-descriptions {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-left: 63px;
      margin-top: -10px;
      .description-row {
        display: flex;
        width: 100px;
        flex-direction: column;
        margin-right: 15%;
        margin-top: 20px;
        &-column {
          .title {
            font-size: 15px;
            margin-top: 9px;
          }
          .total-num {
            margin-top: 9px;
          }
          .yesterday-row {
            font-size: 12px;
            margin-top: 9px;
            color: rgba(16, 16, 16, 0.52);
            display: flex;
            .yesterday-title {
              min-width: 30px;
            }
            .yesterday-count {
              margin-left: 5px;
            }
          }
        }
      }
    }
    .user-reg-statistics {
      width: 100%;
      height: 500px;
      margin-top: 20px;
    }
  }
  &-title {
    font-size: 20px;
    margin-left: 63px;
    margin-top: 10px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
  .title{
    font-size: 80px;
  }
  .total-num{
    font-size: 80px;
  }
}
</style>
